import React from "react";
import {
  Container,
  Box,
  Typography,
  Button,
  Grid,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { scroller } from "react-scroll";

interface Section {
  id: string;
  label: string;
}

type Props = {
  sections: Section[];
  activeSection: string;
  setActiveSection: (id: string) => void;
};

const Header: React.FC<Props> = ({
  sections,
  activeSection,
  setActiveSection,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        // position: "fixed",
        top: 0,
        width: "100%",
        backgroundColor: "white",
        zIndex: 1000,
        boxShadow: 1,
        // paddingBottom: "10%",
        py: { xs: 1, sm: 1.5, md: 2 },
      }}
    >
      <Container id="hello" maxWidth="lg">
        <Grid container spacing={{ xs: 1, sm: 2 }} alignItems="center">
          <Grid size={{ xs: 12, sm: "auto" }}>
            <Typography
              variant="h5"
              component="div"
              sx={{
                fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem" },
              }}
            >
              BÅ Allservice
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: "auto" }} sx={{ ml: { sm: "auto" } }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: { xs: "flex-start", sm: "flex-end" },
                gap: { xs: 1, sm: 1.5, md: 2 },
                flexWrap: "wrap",
              }}
            >
              {sections.map((section) => (
                <Button
                  key={section.label}
                  variant={
                    activeSection === section.id ? "contained" : "text"
                  }
                  onClick={() => {
                    scroller.scrollTo(section.id, {
                      duration: 800,
                      delay: 0,
                      smooth: "easeInOutQuart",
                      offset: 0,
                      containerId: "ContainerElementID",
                    });
                    setActiveSection(section.id);
                  }}
                  sx={{
                    borderRadius: 20,
                    fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" },
                    px: { xs: 1.5, sm: 2 },
                    py: { xs: 0.5, sm: 1 },
                  }}
                >
                  {section.label}
                </Button>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Header;
